export const redirectOnError = (
  history: any,
  errMessage: string,
  navigateTo: string,
  buttonText?: string,
  id?: string,
) => {
  if (
    errMessage &&
    (errMessage.includes("invalid input syntax") ||
      errMessage.includes("no data") ||
      errMessage.includes("not found")) || errMessage.includes("service not found")
  ) {
    history.push({
      pathname: '/404',
      state: {
        message: `The URL that you are trying to visit contains invalid ${id}. It may have been removed or temporarily unavailable.`,
        buttonText, 
        navigateTo
      }
    });
  }
};
